// tslint:disable-next-line:no-namespace
namespace HA.Core.HTML {

    export class Slider extends List {

        protected createSelf() {
            super.createSelf();
            let content: any[];
            const slides = [];
            switch (this.get("ct")) {
                case "m":

                    content = [{
                        c: slides,
                        class: "swiper-wrapper",
                        d: this.get("d"),
                        m: this.get("m"),
                        t: "list",
                    }];
                    break;
                default:
                    const slideContent = toMap(this.get("sc"));
                    if (slideContent.size > 0) {
                        slideContent.forEach((sc) => {
                            slides.push({
                                c: [sc],
                                class: "swiper-slide",
                                t: "div",
                            });
                        });
                    }
                    content = [{
                        c: slides,
                        class: "swiper-wrapper",
                        t: "list",
                    }];
            }

            if (this.get("prev")) {
                content.push({
                    class: "swiper-button-prev",
                    t: "div",
                });
            }
            if (this.get("next")) {
                content.push({
                    class: "swiper-button-next",
                    t: "div",
                });
            }
            if (this.get("scrollbar")) {
                content.push({
                    class: "swiper-scrollbar",
                    t: "div",
                });
            }

            this.appendChildren((new Div({c: content})).getChildren());
        }
    }
}
